import FirstIndianSoldiersAtThermopylaeContent from './content/indian-soldiers-at-thermopylae-content';
import BlogPost from '../blogpost';

export default function FirstIndianSoldiersAtThermopylae() {
  return <BlogPost post={FirstIndianSoldiersAtThermopylaeContent} />;
}